import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMapPin, FiMessageCircle, FiArrowRight } = FiIcons;

const Contact = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="bg-blue-900 py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="text-4xl md:text-6xl font-black text-white mb-8">
              Contato UniPET <span className="text-blue-200">JF</span>
            </h1>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto mb-12 font-medium">
              Agende o banho e tosa do seu pet ou solicite informações no Centro de Juiz de Fora.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="https://wa.me/5532999857587" className="bg-green-500 text-white px-10 py-5 rounded-2xl font-black text-lg hover:bg-green-600 transition-all shadow-xl shadow-black/20 flex items-center gap-3">
                <SafeIcon icon={FiMessageCircle} className="w-6 h-6" /> WhatsApp (32) 99985-7587
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-20">
            <div className="space-y-12">
              <div>
                <h2 className="text-3xl font-extrabold text-gray-900 mb-8">Como agendar banho e tosa em Juiz de Fora?</h2>
                <p className="text-lg text-gray-600 leading-relaxed mb-8 font-medium">
                  Na UniPET, o atendimento é centralizado via WhatsApp para garantir que cada pet receba a atenção necessária. Nossa equipe está pronta para tirar suas dúvidas sobre serviços, valores e horários disponíveis.
                </p>
                <a href="https://wa.me/5532999857587" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-blue-600 font-black text-xl hover:underline gap-2">
                  Chamar agora no WhatsApp <SafeIcon icon={FiArrowRight} />
                </a>
              </div>

              <div className="bg-gray-50 p-10 rounded-[40px] border border-gray-100">
                <h3 className="text-xl font-black text-blue-900 mb-6 uppercase tracking-widest">Informações de Localização</h3>
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <SafeIcon icon={FiMapPin} className="text-blue-900 w-6 h-6 mt-1" />
                    <div>
                      <p className="text-gray-900 font-black text-lg">Rua Delfim Moreira, 125</p>
                      <p className="text-gray-500 font-bold">Centro, Juiz de Fora - MG</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <SafeIcon icon={FiPhone} className="text-blue-900 w-6 h-6 mt-1" />
                    <div>
                      <p className="text-gray-900 font-black text-lg">(32) 99985-7587</p>
                      <p className="text-gray-500 font-bold text-sm uppercase">Atendimento via WhatsApp e Voz</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="aspect-square bg-gray-100 rounded-[50px] overflow-hidden shadow-2xl border-8 border-white ring-1 ring-gray-100">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3705.2940350076146!2d-43.348921423859906!3d-21.76887828007224!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x989b1a9eff60c5%3A0x44742b7404c2434b!2sUniPET%20-%20Banho%20e%20tosa!5e0!3m2!1spt-BR!2sbr!4v1775405286736!5m2!1spt-BR!2sbr" 
                  width="100%" 
                  height="100%" 
                  style={{ border: 0 }} 
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mapa UniPET Juiz de Fora"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;